import DescriptionPaneEditorValue from "./DescriptionPaneEditorValue";

export default DescriptionPaneEditorValue;
export { DescriptionPaneEditorValue };
